/* generated by tools-prices.py — do not hand-edit.
   Source: Prince's setting price workbook. Setting only; no stone.
   Rounded up to the nearest $5. Platinum is priced as 14K. */
window.ARA_PRICES = {
  "currency": "USD",
  "bands": [
    {
      "k": "0.10–0.50",
      "en": "0.10 – 0.50 ct",
      "es": "0.10 – 0.50 ct"
    },
    {
      "k": "0.51–0.99",
      "en": "0.51 – 0.99 ct",
      "es": "0.51 – 0.99 ct"
    },
    {
      "k": "1",
      "en": "1.00 – 1.99 ct",
      "es": "1.00 – 1.99 ct"
    },
    {
      "k": "2",
      "en": "2.00 – 2.99 ct",
      "es": "2.00 – 2.99 ct"
    },
    {
      "k": "3",
      "en": "3.00 – 3.99 ct",
      "es": "3.00 – 3.99 ct"
    },
    {
      "k": "4",
      "en": "4.00 – 4.99 ct",
      "es": "4.00 – 4.99 ct"
    },
    {
      "k": "5",
      "en": "5.00 – 5.99 ct",
      "es": "5.00 – 5.99 ct"
    },
    {
      "k": "6",
      "en": "6.00 – 6.99 ct",
      "es": "6.00 – 6.99 ct"
    },
    {
      "k": "7",
      "en": "7.00 – 7.99 ct",
      "es": "7.00 – 7.99 ct"
    },
    {
      "k": "8",
      "en": "8.00 – 8.99 ct",
      "es": "8.00 – 8.99 ct"
    },
    {
      "k": "9",
      "en": "9.00 – 9.99 ct",
      "es": "9.00 – 9.99 ct"
    },
    {
      "k": "10",
      "en": "10.00 – 10.99 ct",
      "es": "10.00 – 10.99 ct"
    },
    {
      "k": "11",
      "en": "11.00 – 11.99 ct",
      "es": "11.00 – 11.99 ct"
    },
    {
      "k": "12",
      "en": "12.00 – 12.99 ct",
      "es": "12.00 – 12.99 ct"
    },
    {
      "k": "13",
      "en": "13.00 – 13.99 ct",
      "es": "13.00 – 13.99 ct"
    },
    {
      "k": "14",
      "en": "14.00 – 14.99 ct",
      "es": "14.00 – 14.99 ct"
    },
    {
      "k": "15",
      "en": "15.00 ct and above",
      "es": "15.00 ct y más"
    }
  ],
  "pieces": [
    {
      "k": "chain",
      "en": "Chain",
      "es": "Cadena"
    },
    {
      "k": "pendant",
      "en": "Solitaire pendant",
      "es": "Colgante solitario"
    },
    {
      "k": "pendant-bezel",
      "en": "Bezel pendant",
      "es": "Colgante bisel"
    },
    {
      "k": "ring",
      "en": "Solitaire ring",
      "es": "Anillo solitario"
    },
    {
      "k": "ring-bezel",
      "en": "Bezel ring",
      "es": "Anillo bisel"
    },
    {
      "k": "ring-sides",
      "en": "Ring with side diamonds",
      "es": "Anillo con diamantes laterales"
    },
    {
      "k": "earrings",
      "en": "Earrings",
      "es": "Aretes"
    },
    {
      "k": "earrings-dia",
      "en": "Earrings with diamonds",
      "es": "Aretes con diamantes"
    }
  ],
  "metals": [
    {
      "k": "10k",
      "en": "10K gold",
      "es": "Oro 10K",
      "table": "10k"
    },
    {
      "k": "14k",
      "en": "14K gold",
      "es": "Oro 14K",
      "table": "14k"
    },
    {
      "k": "18k",
      "en": "18K gold",
      "es": "Oro 18K",
      "table": "18k"
    },
    {
      "k": "platinum",
      "en": "Platinum",
      "es": "Platino",
      "table": "14k"
    }
  ],
  "table": {
    "10k": [
      [
        405,
        405,
        540,
        675,
        675,
        845,
        675,
        845
      ],
      [
        405,
        405,
        540,
        675,
        675,
        845,
        675,
        845
      ],
      [
        405,
        540,
        675,
        810,
        1015,
        1265,
        1015,
        1265
      ],
      [
        405,
        540,
        675,
        810,
        1015,
        1265,
        1015,
        1265
      ],
      [
        495,
        630,
        765,
        990,
        1125,
        1405,
        1125,
        1405
      ],
      [
        495,
        630,
        765,
        990,
        1240,
        1545,
        1240,
        1545
      ],
      [
        585,
        765,
        990,
        1215,
        1405,
        1760,
        1405,
        1760
      ],
      [
        585,
        765,
        990,
        1125,
        1405,
        1760,
        1405,
        1760
      ],
      [
        585,
        855,
        1080,
        1125,
        1405,
        1760,
        1405,
        1760
      ],
      [
        675,
        855,
        1080,
        1395,
        1575,
        1970,
        1575,
        1970
      ],
      [
        675,
        945,
        1080,
        1395,
        1690,
        2110,
        1690,
        2110
      ],
      [
        675,
        945,
        1260,
        1575,
        1690,
        2110,
        1690,
        2110
      ],
      [
        675,
        1125,
        1440,
        1755,
        2250,
        2815,
        2250,
        2815
      ],
      [
        765,
        1125,
        1440,
        1755,
        2250,
        2815,
        2250,
        2815
      ],
      [
        765,
        1350,
        1665,
        2025,
        2530,
        3165,
        2530,
        3165
      ],
      [
        900,
        1350,
        1665,
        2025,
        2530,
        3165,
        2530,
        3165
      ],
      [
        900,
        1620,
        1935,
        2250,
        2815,
        3515,
        2815,
        3515
      ]
    ],
    "14k": [
      [
        450,
        450,
        600,
        750,
        750,
        940,
        750,
        940
      ],
      [
        450,
        450,
        600,
        750,
        750,
        940,
        750,
        940
      ],
      [
        450,
        600,
        750,
        900,
        1125,
        1410,
        1125,
        1410
      ],
      [
        450,
        600,
        750,
        900,
        1125,
        1410,
        1125,
        1410
      ],
      [
        550,
        700,
        850,
        1100,
        1250,
        1565,
        1250,
        1565
      ],
      [
        550,
        700,
        850,
        1100,
        1375,
        1720,
        1375,
        1720
      ],
      [
        650,
        850,
        1100,
        1350,
        1565,
        1955,
        1565,
        1955
      ],
      [
        650,
        850,
        1100,
        1250,
        1565,
        1955,
        1565,
        1955
      ],
      [
        650,
        950,
        1200,
        1250,
        1565,
        1955,
        1565,
        1955
      ],
      [
        750,
        950,
        1200,
        1550,
        1750,
        2190,
        1750,
        2190
      ],
      [
        750,
        1050,
        1200,
        1550,
        1875,
        2345,
        1875,
        2345
      ],
      [
        750,
        1050,
        1400,
        1750,
        1875,
        2345,
        1875,
        2345
      ],
      [
        750,
        1250,
        1600,
        1950,
        2500,
        3125,
        2500,
        3125
      ],
      [
        850,
        1250,
        1600,
        1950,
        2500,
        3125,
        2500,
        3125
      ],
      [
        850,
        1500,
        1850,
        2250,
        2815,
        3520,
        2815,
        3520
      ],
      [
        1000,
        1500,
        1850,
        2250,
        2815,
        3520,
        2815,
        3520
      ],
      [
        1000,
        1800,
        2150,
        2500,
        3125,
        3910,
        3125,
        3910
      ]
    ],
    "18k": [
      [
        495,
        495,
        660,
        825,
        825,
        1030,
        825,
        1030
      ],
      [
        495,
        495,
        660,
        825,
        825,
        1030,
        825,
        1030
      ],
      [
        495,
        660,
        825,
        990,
        1240,
        1545,
        1240,
        1545
      ],
      [
        495,
        660,
        825,
        990,
        1240,
        1545,
        1240,
        1545
      ],
      [
        605,
        770,
        935,
        1210,
        1375,
        1720,
        1375,
        1720
      ],
      [
        605,
        770,
        935,
        1210,
        1515,
        1890,
        1515,
        1890
      ],
      [
        715,
        935,
        1210,
        1485,
        1720,
        2150,
        1720,
        2150
      ],
      [
        715,
        935,
        1210,
        1375,
        1720,
        2150,
        1720,
        2150
      ],
      [
        715,
        1045,
        1320,
        1375,
        1720,
        2150,
        1720,
        2150
      ],
      [
        825,
        1045,
        1320,
        1705,
        1925,
        2405,
        1925,
        2405
      ],
      [
        825,
        1155,
        1320,
        1705,
        2065,
        2580,
        2065,
        2580
      ],
      [
        825,
        1155,
        1540,
        1925,
        2065,
        2580,
        2065,
        2580
      ],
      [
        825,
        1375,
        1760,
        2145,
        2750,
        3440,
        2750,
        3440
      ],
      [
        935,
        1375,
        1760,
        2145,
        2750,
        3440,
        2750,
        3440
      ],
      [
        935,
        1650,
        2035,
        2475,
        3095,
        3865,
        3095,
        3865
      ],
      [
        1100,
        1650,
        2035,
        2475,
        3095,
        3865,
        3095,
        3865
      ],
      [
        1100,
        1980,
        2365,
        2750,
        3440,
        4295,
        3440,
        4295
      ]
    ]
  }
};
